// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import InputRange from '../../../../shared/components/facets/input-range';
import Range from '@deere/cps-it.warranty-model-factory/lib/range';
import {isValidRange} from '../../services/is-valid-range';
import {translate} from '../../../../shared/services/translation-service';

const ReimbursementFacetItem = props =>
    <section className='reimbursement-amount'>
        <header className='facet-title'>
            <FormattedMessage id={props.label}/>
        </header>
        <InputRange
            isValidRange={isValidRange}
            max={props.range.max}
            maximumRangePlaceholder={translate('TO')}
            min={props.range.min}
            minimumRangePlaceholder={translate('FROM')}
            onInputRangeChange={props.onRangeChange}
        />
        <button onClick={props.onButtonClick}>
            <FormattedMessage id={props.buttonLabel}/>
        </button>
    </section>;

ReimbursementFacetItem.displayName = 'ReimbursementFacetItem';
ReimbursementFacetItem.propTypes = {
    buttonLabel: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onButtonClick: PropTypes.func.isRequired,
    onRangeChange: PropTypes.func.isRequired,
    range: PropTypes.instanceOf(Range).isRequired
};

export default ReimbursementFacetItem;




// WEBPACK FOOTER //
// ./src/tcsm/claim-search/components/facets/reimbursement-facet-item.js